import React, { Component } from 'react';
import { Helmet } from 'react-helmet';

import CustomersContainer from '../../../containers/Customers'

class Customers extends Component {
  render() {
    return (
      <React.Fragment>
         <Helmet
            titleTemplate="%s - Xelacore PLM Backoffice"
          >
          <title>Customers</title>
            <meta name="description" content="Xelacore PLM Backoffice" />
          </Helmet>
          <CustomersContainer {...this.props}/>
      </React.Fragment>
    );
  }
}

export default Customers;



// WEBPACK FOOTER //
// ./src/views/Pages/Customers/Customers.js